import { OwcButton, OwcIcon, OwcHyperlink } from "@one/react";
import { isAddBookingDisabled, isSaveBookingDisabled } from "./helpers/bookingValidation";

const BookingActionButtons = ({
  isEditMode,
  isDuplicate,
  activeTab,
  isLegendVisible,
  setIsLegendVisible,
  handlerOnAddBooking,
  handleOpen,
  formik,
  disabledSelection,
  pendingReservations,
  compareValues,
  isConflict
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      {activeTab === 2 && (
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '4px' }}>
          <OwcIcon name="tip" />
          <span><strong>Quick tip:</strong> Click the timeline to define your booking's timeframe</span>
          <OwcHyperlink
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setIsLegendVisible((prev) => !prev);
            }}
            style={{ marginLeft: "4px" }}
          >
            {isLegendVisible ? 'Hide legend' : 'Show legend'}
          </OwcHyperlink>
        </div>
      )}
      {(!isEditMode || isDuplicate) && activeTab !== 1 && (
        <OwcButton
          style={{ float: "right", marginLeft: 'auto' }}
          data-testid="whom-tab-confrim-button"
          variant="primary"
          onClick={handlerOnAddBooking}
          disabled={isAddBookingDisabled(formik, isDuplicate, pendingReservations, disabledSelection, isConflict)}
        >
          Confirm
        </OwcButton>
      )}

      {(isEditMode && !isDuplicate) && activeTab !== 1 && (
        <OwcButton
          style={{ float: "right", marginLeft: 'auto' }}
          data-testid="whom-tab-confrim-button"
          variant="primary"
          onClick={handleOpen}
          disabled={isSaveBookingDisabled(formik, disabledSelection, pendingReservations, compareValues)}
        >
          Save
        </OwcButton>
      )}
    </div>
  );
};

export default BookingActionButtons;
